import { addPlayer } from '../utilities/backendApi';
export async function attemptToAddPlayer(org_uid) {
    return await addPlayer({ org_uid: org_uid });
}
